export default __webpack_public_path__ + "static/media/1.3829ce0e.jpg";